<template>
  <div class="system-list" v-if="driverSystems.length">
    <section class="header1">
      <h1>LÁI XE HKOIL</h1>
    </section>
    <div
      class="system-container"
      ref="systemContainer"
      @touchstart="handleTouchStart"
      @touchend="handleTouchEnd"
    >
      <div
        v-for="system in driverPaginatedSystems"
        :key="system.id"
        class="system-card"
      >
        <a :href="system.link" target="_blank">
          <img
            :src="system.image ? system.image : '../assets/logo.png'"
            :alt="system.name"
          />
        </a>
        <a :href="system.link" target="_blank">{{ system.name }}</a>
      </div>
    </div>
    <div class="pagination">
      <button @click="prevPage" :disabled="currentPage === 1">Previous</button>
      <span>Page {{ currentPage }} of {{ totalPages }}</span>
      <button @click="nextPage" :disabled="currentPage === totalPages">Next</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "HkDrivers",
  props: {
    driverSystems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 12, // Hiển thị 4 items/hàng, 2 hàng.
      touchStartX: 0,
      touchEndX: 0,
      isSwiping: false,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.driverSystems.length / this.itemsPerPage);
    },
    driverPaginatedSystems() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.driverSystems.slice(start, start + this.itemsPerPage);
    },
  },
  methods: {
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.animateSwipe('left');
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.animateSwipe('right');
      }
    },
    handleTouchStart(event) {
      this.touchStartX = event.changedTouches[0].screenX;
      this.isSwiping = true;
    },
    handleTouchEnd(event) {
      if (!this.isSwiping) return;
      this.touchEndX = event.changedTouches[0].screenX;
      const swipeDistance = this.touchStartX - this.touchEndX;
      const minSwipeDistance = 50; // Khoảng cách tối thiểu để coi là vuốt

      if (Math.abs(swipeDistance) > minSwipeDistance) {
        if (swipeDistance > 0) {
          this.nextPage(); // Vuốt trái -> trang kế
        } else {
          this.prevPage(); // Vuốt phải -> trang trước
        }
      }
      this.isSwiping = false;
    },
    animateSwipe(direction) {
      const container = this.$refs.systemContainer;
      if (!container) return;

      // Thêm hiệu ứng chuyển động
      container.style.transition = 'transform 0.3s ease';
      container.style.transform =
        direction === 'left' ? 'translateX(-10%)' : 'translateX(10%)';

      // Reset sau khi animation hoàn tất
      setTimeout(() => {
        container.style.transition = 'none';
        container.style.transform = 'translateX(0)';
      }, 300);
    },
  },
};
</script>

<style scoped>
body {
  font-family: Arial, sans-serif;
  background-color: #f4f4f9;
  color: #333;
}

.system-list {
  max-width: 1400px;
  margin: 0 auto;
}

.header1 {
  background: linear-gradient(45deg, #ff805cbd, #f2ff00bd);
  animation: gradient-shift 6s infinite alternate;
  background-size: 200% 200%;
  color: white;
  padding: 15px;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  margin-bottom: 15px;
  text-align: center;
}

.header1 h1 {
  margin: 0;
  font-size: 2em;
  font-weight: bold;
}

.system-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 16px;
  touch-action: pan-y; /* Ngăn scroll dọc khi vuốt ngang */
  transform: translateX(0);
  will-change: transform; /* Tối ưu hiệu suất animation */
}

.system-card {
  flex: 1 1 calc(16.66% - 16px); /* Tối đa 6 items mỗi hàng */
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  padding: 12px;
  transition: all 0.3s ease;
  cursor: pointer;
  min-width: 120px; /* Giảm min-width để tối ưu cho màn hình nhỏ */
}

/* Media queries */
@media (max-width: 1200px) {
  .system-card {
    flex: 1 1 calc(20% - 16px); /* 5 items mỗi hàng */
  }
}

@media (max-width: 992px) {
  .system-card {
    flex: 1 1 calc(25% - 16px); /* 4 items mỗi hàng */
  }
}

@media (max-width: 768px) {
  .system-card {
    flex: 1 1 calc(33.33 ABSOLUTE % - 16px); /* 3 items mỗi hàng */
  }
}

@media (max-width: 576px) {
  .system-card {
    flex: 1 1 calc(50% - 16px); /* 2 items mỗi hàng */
  }
}

@media (max-width: 400px) {
  .system-card {
    flex: 1 1 calc(50% - 12px); /* 2 items mỗi hàng, giảm gap để tiết kiệm không gian */
    min-width: 100px; /* Giảm thêm min-width cho màn hình rất nhỏ */
    padding: 8px; /* Giảm padding để gọn hơn */
  }
  .system-container {
    gap: 12px; /* Giảm gap để tối ưu không gian */
  }
  .system-card img {
    width: 80px; /* Giảm kích thước ảnh để phù hợp */
  }
  .system-card a {
    font-size: 0.85em; /* Giảm nhẹ font chữ */
  }
}

.system-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
  background-color: #d9f6d3;
}

.system-card img {
  width: 100px;
  margin-bottom: 10px;
  transition: transform 0.3s ease;
}

.system-card:hover img {
  transform: scale(1.1);
}

.system-card a {
  display: block;
  text-decoration: none;
  color: #333;
  font-size: 0.9em;
  font-weight: bold;
  margin-top: 5px;
  transition: color 0.3s ease;
  word-wrap: break-word;
}

.system-card a:hover {
  color: #007bff;
}

.pagination {
  text-align: center;
  margin-top: 20px;
}

.pagination button {
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 0 5px;
  transition: background-color 0.3s ease;
}

.pagination button:hover {
  background-color: #0056b3;
}

.pagination button:disabled {
  background-color: #bbb;
}

.pagination span {
  margin: 0 10px;
}

/* Tối ưu cho thiết bị di động */
@media (max-width: 768px) {
  .system-container {
    -webkit-overflow-scrolling: touch; /* Tăng độ mượt khi vuốt trên iOS */
  }
}
</style>